<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-3
            b.has-text-black(@click="backPage")
              a.button.is-light.is-rounded
                span.icon
                  i.fas.fa-angle-left
                | &nbspRegresar
          .column.is-offset-2.is-2(v-show="permisos.sca_irge == 1")
            b.has-text-black
              router-link.a.button.is-fullwidth.is-light.is-rounded(to="/IRGE/SCA/Grupos")
                | Gestionar grupos
          .column.is-offset-2.is-2
            b.has-text-black
              router-link.a.button.is-fullwidth.is-light.is-rounded(to="/IRGE/SCA/Consumos")
                | Ver Tabla Comparativa&nbsp
                span.icon
                i.fas.fa-angle-right
        .columns.is-vcentered
          .column.is-1
            label.label Fecha
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='fechaJornada'
                  :config="config"
                  class="input"
                )
          .column.is-1
            a.button.is-black.is-rounded.is-small(@click="iniciarComponente")
              span.icon
                i.fas.fa-sync
          .column.is-1
            a.button.is-warning.is-rounded.is-small(v-show="solicitudes.length >0" @click="aceptarSolicitudCargas")
              | Aceptar Solicitud de cargas &nbsp
          .column.is-offset-3.is-1
            label.label Buscar
          .column.is-3
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por PG | Sello',
                  v-model="query",
                )
        .columns.is-multiline.has-text-centered
          .column(v-for="p in porcentajes")
            CardSubgrupo(:data="p" :key="p.unidadNeg")
        br
        .columns
          .column.is-12
            div.control
              label.radio.label-radio.is-primary
                input#iALL.is-primary(type='radio', value='ALL' v-model='filter' checked='checked')
                | TODOS
              label.radio.label-radio.is-primary(v-for="porc in porcentajes") 
                input.is-radio-input.is-primary(type='radio' :value='porc.unidadNeg' v-model='filter' :id="porc.unidadNeg")
                | {{ porc.negocio}}
        .columns
          .column.is-12
            ContainerAutotanques(:autotanques="aTLlegandoShow" :nominaciones="porcentajes" :grupos="grupos" @eventLoading="eventLoading" @updateAutanques="updateAutanques")
        .columns.column-blanco
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBar from './layout/NavBar.vue'
  import CardSubgrupo from './componentes/CardSubgrupo'
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import { mapState } from 'vuex'
  
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"

  import nominaciones_irgeServices from '@/services/sca/nominaciones/nominacionesIrge.js'
  import accesos_irgeServices from '@/services/sca/accesos/accesosIRGE.js'
  import sca_irgeServices from '@/services/sca/irge.js'
  import ContainerAutotanques from './componentes/ContainerAutotanques.vue'
import api_cargas_irge from '../../../../services/sca/apiCargasIrge'

  export default {
    name: 'HomeCuartoControl',
    components: { Loader, NavBar, flatPickr, CardSubgrupo, ContainerAutotanques },
    data() {
      return {
        isLoading: true,
        fechaJornada: moment().format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        nominaciones: [],
        aTLlegando: [],
        aTLlegandoShow: [],
        aTPrograma: [],
        aTDocumentados: [],
        porcentajes: [],
        aTCargados: [],
        filter: 'ALL',
        query: '',
        grupos: [],
        configuracion: {},
        verPorcentajePostCarga: true,
        solicitudes: [],
      }
    },
    watch: {
      fechaJornada() {
        this.iniciarComponente()
        this.filter = 'ALL'
      },
      filter () {
        if (this.filter === 'ALL') {
          this.aTLlegandoShow = this.aTLlegando
        } else {
          this.aTLlegandoShow = this.aTLlegando.filter( at => at.subgrupo === this.filter)
        }
      },
      query () {
        const QUERY = this.query.toUpperCase()
        const accesosFilter = this.aTLlegando.filter( acc => {
          const sellosArray = []
          acc.sellos.map( sell => sellosArray.push(sell.sello))
          let sellosText = ''
          for (let index = 0; index < sellosArray.length; index++) {
            sellosText += `${sellosArray[index]} `
            
          }
          return `${acc.pg} ${sellosText}`.toUpperCase().includes(QUERY)
        })
        this.aTLlegandoShow = accesosFilter
      }
    },
    methods: {
      iniciarComponente () {
        this.isLoading = true
        this.obtenerConfiguracion()
        this.obtenerSolicitudes()
      },

      obtenerConfiguracion () {
        this.configuracion = {}
        sca_irgeServices.obtenerConfiguracion()
          .then( data => {
            this.configuracion = this.convertirConfiguracion(data[0])
              this.verPorcentajePostCarga = this.configuracion.porcentajePostCarga
            this.obtenerGrupos()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
        
      },

      convertirConfiguracion(config) {
        return {
          ...config,
          porcentajePostCarga: Number(config.porcentaje_postCargas) == 1 ? true : false,
        }
      },

      obtenerGrupos () {
        sca_irgeServices.getSubgrupos_nominaciones(this.fechaJornada)
          .then(data => {
            this.grupos = data
            this.obtenerNominacionFecha()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      obtenerNominacionFecha () {
        nominaciones_irgeServices.obtenerNominacionFecha(this.fechaJornada)
          .then( data => {
            this.nominaciones = data.map(this.convetirNominaciones)
            console.log(this.nominaciones)
            this.obtenerAutotanques()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convetirNominaciones(nom) {
        return {
          ...nom,
          id: parseInt(nom.id),
          nominacion: parseFloat(nom.nominacion).toFixed(1)
        }
      },

      obtenerAutotanques() {
        accesos_irgeServices.getAccesos(this.fechaJornada)
          .then( data => {
            this.aTLlegando = data.map(this.convetirAutotanques)
            this.aTLlegandoShow = this.aTLlegando
            this.obtenerCargas()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convetirAutotanques (auto) {
        return {
          ...auto,
          id: parseInt(auto.id),
          embarque: parseInt(auto.embarque),
          estado: parseInt(auto.estado),
          programa: parseInt(auto.programa),
          presion: Number(auto.presion),
          magnatel: Number(auto.magnatel),
          visita: parseInt(auto.visita),
          ultimaCarga: parseInt(auto.ultimaCarga),
        }
      },

      obtenerCargas () {
        sca_irgeServices.getCargas(this.fechaJornada)
          .then( data => {
            this.aTCargados = data.map(this.convetirCargas)
            this.calcularPorcentajes()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convetirCargas (carga) {
        const pgCargado = this.aTLlegando.some( pg => pg.pg === carga.pg)
        let subgrupo = ''
        if (pgCargado) {
          const pgsAcc = this.aTLlegando.filter( pg => pg.pg === carga.pg)
          const existeVisita =  pgsAcc.some( pg => pg.visita == carga.visita)
          if (existeVisita) {
            const pgFinded = pgsAcc.find( pg => pg.visita == carga.visita)
            subgrupo = pgFinded.subgrupo
          }
        }
        return {
          ...carga,
          id: parseInt(carga.id),
          capacidad90: Number(carga.capacidad90),
          capturado: parseInt(carga.capturado),
          contenido: Number(carga.contenido),
          densidad: Number(carga.densidad),
          densidad20: Number(carga.densidad20),
          folioCarga: Number(carga.folioCarga),
          masa: Number(carga.masa),
          masaKgs: Number(carga.masaKgs),
          masaPura: Number(carga.masaPura),
          porcentaje: Number(carga.porcentaje),
          presion: Number(carga.presion),
          temperatura: Number(carga.temperatura),
          volumen: Number(carga.volumen),
          volumen20: Number(carga.volumen20),
          subgrupo: subgrupo,
          visita: parseInt(carga.visita)
        }
      },

      calcularPorcentajes() {
        this.porcentajes = this.nominaciones.map(this.convetirPorcentajes)
        this.isLoading = false
      },

      convetirPorcentajes (nom) {
        if (this.verPorcentajePostCarga) {
          const tanquesNom = this.aTCargados.filter( pg => pg.subgrupo === nom.unidadNeg)
          const masaSurtida = (tanquesNom.reduce( (acc, { masa } ) => acc + masa, 0)).toFixed(3)
          const porcentajeSurtido = ((masaSurtida * 100) / nom.nominacion).toFixed(2)
          const restante = (nom.nominacion - masaSurtida).toFixed(3)
          return {
            ...nom,
            surtido: Number(masaSurtida),
            porcentaje: Number(porcentajeSurtido),
            restante: Number(restante),
            negocio: nom.subgrupo,
            compania: nom.nombreCompania,
            orden: parseInt(nom.orden)
          }
        } else {
          const tanquesNom = this.aTCargados.filter( pg => pg.subgrupo === nom.unidadNeg)
          const masaSurtida = (tanquesNom.reduce( (acc, { masa } ) => acc + masa, 0)).toFixed(3)
          const tanquesNoSurtidos = this.aTLlegando.filter( pgAccesos => {
            const pgNoCargado = this.aTCargados.some( pgCargado => pgCargado.pg === pgAccesos.pg)
            if (pgNoCargado) {
              return null
            } else {
              return pgAccesos
            }
          })
          console.log(`Nominacion de ${nom.subgrupo}: ${nom.nominacion}`)
          console.log(tanquesNoSurtidos)
          const tanquesNoSurtidosNom = tanquesNoSurtidos.filter(pg => pg.subgrupo === nom.unidadNeg )
          console.log(tanquesNoSurtidosNom)
          const masaNoSurtidaAun = (tanquesNoSurtidosNom.reduce( (acc, { ultimaCarga } ) => acc + ultimaCarga, 0)).toFixed(3)
          console.log(`Masa no surtida aun: ${Number(masaNoSurtidaAun)}`)
          console.log(`Masa ya surtida: ${Number(masaSurtida)}`)
          const masaAproximada = Number(masaNoSurtidaAun) + Number(masaSurtida)
          console.log(`Masa Aproximada: ${masaAproximada}`)
          const porcentajeSurtido = ((masaAproximada * 100) / nom.nominacion).toFixed(2)
          console.log(`Porcentaje ${porcentajeSurtido}`)
          const restante = (nom.nominacion - masaAproximada).toFixed(3)
          console.log(`Restante: ${restante}`)
          return {
            ...nom,
            surtido: Number(masaAproximada),
            porcentaje: Number(porcentajeSurtido),
            restante: Number(restante),
            negocio: nom.subgrupo,
            compania: nom.nombreCompania,
            orden: parseInt(nom.orden)
          }
        }
        
      },

      eventLoading (val) {
        this.isLoading = val
      }, 

      updateAutanques (val) {
        if (val) {
          this.obtenerAutotanques()
        }
      },

      obtenerSolicitudes() {
        console.log(2)
        sca_irgeServices.getSolicitudCargasPendientes()
          .then( resp => {
            console.log(resp)
            this.solicitudes = resp
          })
          .catch(e => {
            console.log(e)
          })
      },

      aceptarSolicitudCargas() {
        console.log('Aceptar Solicitud')
        const solicitud = this.solicitudes[0]
        console.log("🚀 ~ file: HomeCuartoControl.vue:356 ~ aceptarSolicitudCargas ~ solicitud:", solicitud)
        sca_irgeServices.updateSolicitudCargasPendientes(solicitud.id)
          .then( resp => {
            console.log(resp)
            this.displayToast('success','La solicitud ha sido aceptada', 'done', 'OK', null)
            this.obtenerCargasPerdidas()
            this.obtenerSolicitudes()
          })
          .catch(e => {
            console.log(e)
          })
        
      },

      obtenerCargasPerdidas() {
        this.isLoading = true
        const fecha = moment(this.fechaJornada).format('YYYY-MM-DD')
        const obj = { fecha }
        api_cargas_irge.getCargasFaltantes(obj)
        .then( resp => {
          this.displayToast('success', resp.message, 'done', 'OK')
          this.isLoading = false
        })
        .catch(e => {
            console.log(e)
            this.isLoading = false
        })
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema === 'success' ? 'toasted-primary' : 'bubble', 
          position: "bottom-right", 
          duration : 2000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      backPage() {
        this.$router.back()
      },
    },
    computed: {
      ...mapState(["permisos"]),
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
  .label-radio {
    margin-right: 10px;
  }
  .is-radio-input {
    padding-right: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/cuartocontrol/HomeCuartoControl.vue